
import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './Login.css';

import AdminLoginForm from '../../../components/SiteAdmin/AdminLoginForm';

class Login extends React.Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
  };

  render() {
    return (
      <div>
          <AdminLoginForm />
      </div>
    );
  }
}

export default withStyles(s)(Login);